import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/utils';

export const footerVariants = cva('flex', {
  variants: {
    type: {
      desktop: 'flex-row justify-end space-x-2',
      mobile: 'flex-col-reverse space-y-2',
      responsive: 'flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2',
    },
  },
  defaultVariants: {
    type: 'responsive',
  },
});

type AlertDialogFooterProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof footerVariants>;

export const AlertDialogFooter = ({ className, type, ...props }: AlertDialogFooterProps) => (
  <div className={cn(footerVariants({ type }), className)} {...props} />
);
